webpackJsonp([72481519496252],{

/***/ 309:
/***/ (function(module, exports) {

	/*!
	 * for-in <https://github.com/jonschlinkert/for-in>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	module.exports = function forIn(obj, fn, thisArg) {
	  for (var key in obj) {
	    if (fn.call(thisArg, obj[key], key, obj) === false) {
	      break;
	    }
	  }
	};


/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * for-own <https://github.com/jonschlinkert/for-own>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	var forIn = __webpack_require__(309);
	var hasOwn = Object.prototype.hasOwnProperty;
	
	module.exports = function forOwn(obj, fn, thisArg) {
	  forIn(obj, function(val, key) {
	    if (hasOwn.call(obj, key)) {
	      return fn.call(thisArg, obj[key], key, obj);
	    }
	  });
	};


/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(162);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),

/***/ 359:
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(367),
	    isArguments = __webpack_require__(382),
	    isArray = __webpack_require__(100),
	    isBuffer = __webpack_require__(383),
	    isIndex = __webpack_require__(373),
	    isTypedArray = __webpack_require__(386);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(363),
	    createBaseEach = __webpack_require__(370);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(371);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(362),
	    keys = __webpack_require__(387);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(160),
	    getRawTag = __webpack_require__(372),
	    objectToString = __webpack_require__(377);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(99),
	    isObjectLike = __webpack_require__(101);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(99),
	    isLength = __webpack_require__(164),
	    isObjectLike = __webpack_require__(101);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(374),
	    nativeKeys = __webpack_require__(375);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),

/***/ 367:
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),

/***/ 368:
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(381);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(163);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),

/***/ 371:
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),

/***/ 161:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(160);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),

/***/ 373:
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),

/***/ 374:
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(378);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(161);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(197)(module)))

/***/ }),

/***/ 377:
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),

/***/ 378:
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(161);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(380);


/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(359),
	    baseEach = __webpack_require__(361),
	    castFunction = __webpack_require__(369),
	    isArray = __webpack_require__(100);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ }),

/***/ 381:
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(364),
	    isObjectLike = __webpack_require__(101);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),

/***/ 100:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(384),
	    isLength = __webpack_require__(164);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(162),
	    stubFalse = __webpack_require__(388);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(197)(module)))

/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(99),
	    isObject = __webpack_require__(385);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),

/***/ 164:
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),

/***/ 385:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),

/***/ 101:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(365),
	    baseUnary = __webpack_require__(368),
	    nodeUtil = __webpack_require__(376);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(360),
	    baseKeys = __webpack_require__(366),
	    isArrayLike = __webpack_require__(163);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),

/***/ 388:
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),

/***/ 62:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * reduce-object <https://github.com/jonschlinkert/reduce-object>
	 *
	 * Copyright (c) 2014 Jon Schlinkert, contributors.
	 * Licensed under the MIT License
	 */
	
	'use strict';
	
	var forOwn = __webpack_require__(310);
	
	module.exports = function reduce(o, fn, acc, thisArg) {
	  var first = arguments.length > 2;
	
	  if (o && !Object.keys(o).length && !first) {
	    return null;
	  }
	
	  forOwn(o, function (value, key, orig) {
	    if (!first) {
	      acc = value;
	      first = true;
	    } else {
	      acc = fn.call(thisArg, acc, value, key, orig);
	    }
	  });
	
	  return acc;
	};


/***/ }),

/***/ 197:
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _render = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function () {
	  /*============================================================
	                              SLIDE
	  ============================================================*/
	
	  (0, _render.render)('text-input', function () {
	    var App = function App() {
	      return _react2.default.createElement('input', { type: 'text' });
	    };
	    return _react2.default.createElement(App, null);
	  });
	
	  /*============================================================
	                            SLIDE
	  ============================================================*/
	
	  (0, _render.render)('text-input-reverse', function () {
	    var App = function (_React$Component) {
	      _inherits(App, _React$Component);
	
	      function App() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, App);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	          textValue: ''
	        }, _this.setText = function (text) {
	          _this.setState({ textValue: text });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      App.prototype.render = function render() {
	        var _this2 = this;
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('input', {
	            value: this.state.value,
	            onChange: function onChange(e) {
	              return _this2.setText(e.target.value);
	            }
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'text' },
	            ' ',
	            'Reverse text is: ',
	            _react2.default.createElement('br', null),
	            ' ',
	            this.state.textValue.split('').reverse().join('')
	          ),
	          _react2.default.createElement(
	            'button',
	            null,
	            ' Post '
	          )
	        );
	      };
	
	      return App;
	    }(_react2.default.Component);
	
	    return _react2.default.createElement(App, null);
	  });
	
	  /*============================================================
	                                Clear example
	    ============================================================*/
	
	  (0, _render.render)('text-input-clear', function () {
	    var App = function (_React$Component2) {
	      _inherits(App, _React$Component2);
	
	      function App() {
	        var _temp2, _this3, _ret2;
	
	        _classCallCheck(this, App);
	
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          args[_key2] = arguments[_key2];
	        }
	
	        return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, _React$Component2.call.apply(_React$Component2, [this].concat(args))), _this3), _this3.state = {
	          textValue: ''
	        }, _this3.setText = function (text) {
	          _this3.setState({ textValue: text });
	        }, _this3.clearField = function () {
	          _this3.setState({ textValue: '' });
	        }, _temp2), _possibleConstructorReturn(_this3, _ret2);
	      }
	
	      App.prototype.render = function render() {
	        var _this4 = this;
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('input', {
	            style: { marginBottom: 10 },
	            value: this.state.textValue,
	            onChange: function onChange(e) {
	              return _this4.setText(e.target.value);
	            }
	          }),
	          _react2.default.createElement(
	            'button',
	            { onClick: this.clearField },
	            ' clear '
	          )
	        );
	      };
	
	      return App;
	    }(_react2.default.Component);
	
	    return _react2.default.createElement(App, null);
	  });
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _render = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function () {
	  /*============================================================
	                              click-button-alert
	  ============================================================*/
	
	  (0, _render.render)('click-button-alert', function () {
	    var handleClick = function handleClick(e) {
	      alert('Clicked!');
	    };
	
	    var App = function App() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { onClick: handleClick },
	          'Click me!'
	        )
	      );
	    };
	
	    return _react2.default.createElement(App, null);
	  });
	
	  /*============================================================
	                              SLIDE
	  ============================================================*/
	
	  (0, _render.render)('modifying-variables', function () {
	    var isActive = false;
	
	    var handleClick = function handleClick() {
	      isActive = !isActive;
	      alert(isActive);
	    };
	
	    var App = function App() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { style: { marginBottom: 10 }, onClick: handleClick },
	          'Toggle'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'text' },
	          isActive ? 'On' : 'Off'
	        )
	      );
	    };
	
	    return _react2.default.createElement(App, null);
	  });
	
	  /*============================================================
	                            SLIDE
	  ============================================================*/
	
	  (0, _render.render)('first-stateful', function () {
	    var App = function (_React$Component) {
	      _inherits(App, _React$Component);
	
	      function App() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, App);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	          isActive: false
	        }, _this.handleClick = function () {
	          _this.setState({
	            isActive: !_this.state.isActive
	          });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      App.prototype.render = function render() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'button',
	            { style: { marginBottom: 15 }, onClick: this.handleClick },
	            'Toggle'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'text' },
	            this.state.isActive ? 'On' : 'Off'
	          )
	        );
	      };
	
	      return App;
	    }(_react2.default.Component);
	
	    return _react2.default.createElement(App, null);
	  });
	
	  /*============================================================
	                            SLIDE
	  ============================================================*/
	
	  (0, _render.render)('light-switch', function () {
	    var LightSwitch = function LightSwitch(_ref) {
	      var active = _ref.active;
	      return _react2.default.createElement(
	        'div',
	        { className: 'text' },
	        'Switch is ',
	        active ? 'on' : 'off'
	      );
	    };
	
	    var App = function (_React$Component2) {
	      _inherits(App, _React$Component2);
	
	      function App() {
	        var _temp2, _this2, _ret2;
	
	        _classCallCheck(this, App);
	
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          args[_key2] = arguments[_key2];
	        }
	
	        return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _React$Component2.call.apply(_React$Component2, [this].concat(args))), _this2), _this2.state = {
	          isActive: false
	        }, _this2.handleToggle = function () {
	          _this2.setState({ isActive: !_this2.state.isActive });
	        }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	      }
	
	      App.prototype.render = function render() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'button',
	            { onClick: this.handleToggle },
	            ' Toggle '
	          ),
	          _react2.default.createElement(LightSwitch, { active: this.state.isActive })
	        );
	      };
	
	      return App;
	    }(_react2.default.Component);
	
	    return _react2.default.createElement(App, null);
	  });
	
	  /*============================================================
	                            SLIDE
	  ============================================================*/
	
	  (0, _render.render)('switch-interactive', function () {
	    var LightSwitch = function LightSwitch(_ref2) {
	      var active = _ref2.active,
	          onToggle = _ref2.onToggle;
	      return _react2.default.createElement(
	        'button',
	        { style: { margin: '15px 0' }, onClick: onToggle },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Switch is ',
	          active ? 'on' : 'off'
	        )
	      );
	    };
	
	    var App = function (_React$Component3) {
	      _inherits(App, _React$Component3);
	
	      function App() {
	        var _temp3, _this3, _ret3;
	
	        _classCallCheck(this, App);
	
	        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	          args[_key3] = arguments[_key3];
	        }
	
	        return _ret3 = (_temp3 = (_this3 = _possibleConstructorReturn(this, _React$Component3.call.apply(_React$Component3, [this].concat(args))), _this3), _this3.state = {
	          isActive: false
	        }, _this3.handleToggle = function () {
	          _this3.setState({ isActive: !_this3.state.isActive });
	        }, _temp3), _possibleConstructorReturn(_this3, _ret3);
	      }
	
	      App.prototype.render = function render() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(LightSwitch, {
	            active: this.state.isActive,
	            onToggle: this.handleToggle
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'text' },
	            this.state.isActive ? 'On' : 'Off'
	          ),
	          _react2.default.createElement(LightSwitch, {
	            active: this.state.isActive,
	            onToggle: this.handleToggle
	          })
	        );
	      };
	
	      return App;
	    }(_react2.default.Component);
	
	    return _react2.default.createElement(App, null);
	  });
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _render = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function () {
	  (0, _render.render)('text-input', function () {
	    var App = function App() {
	      return _react2.default.createElement('input', { type: 'text' });
	    };
	    return _react2.default.createElement(App, null);
	  });
	
	  /*============================================================
	                            SLIDE
	  ============================================================*/
	
	  (0, _render.render)('text-input-reverse', function () {
	    var App = function (_React$Component) {
	      _inherits(App, _React$Component);
	
	      function App() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, App);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	          textValue: ''
	        }, _this.setText = function (text) {
	          _this.setState({ textValue: text });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      App.prototype.render = function render() {
	        var _this2 = this;
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('input', {
	            value: this.state.value,
	            onChange: function onChange(e) {
	              return _this2.setText(e.target.value);
	            }
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'text' },
	            ' ',
	            'Reverse text is: ',
	            _react2.default.createElement('br', null),
	            ' ',
	            this.state.textValue.split('').reverse().join('')
	          ),
	          _react2.default.createElement(
	            'button',
	            null,
	            ' Post '
	          )
	        );
	      };
	
	      return App;
	    }(_react2.default.Component);
	
	    return _react2.default.createElement(App, null);
	  });
	
	  /*============================================================
	                                Clear example
	    ============================================================*/
	
	  (0, _render.render)('text-input-clear', function () {
	    var App = function (_React$Component2) {
	      _inherits(App, _React$Component2);
	
	      function App() {
	        var _temp2, _this3, _ret2;
	
	        _classCallCheck(this, App);
	
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          args[_key2] = arguments[_key2];
	        }
	
	        return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, _React$Component2.call.apply(_React$Component2, [this].concat(args))), _this3), _this3.state = {
	          textValue: ''
	        }, _this3.setText = function (text) {
	          _this3.setState({ textValue: text });
	        }, _this3.clearField = function () {
	          _this3.setState({ textValue: '' });
	        }, _temp2), _possibleConstructorReturn(_this3, _ret2);
	      }
	
	      App.prototype.render = function render() {
	        var _this4 = this;
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('input', {
	            style: { marginBottom: 10 },
	            value: this.state.textValue,
	            onChange: function onChange(e) {
	              return _this4.setText(e.target.value);
	            }
	          }),
	          _react2.default.createElement(
	            'button',
	            { onClick: this.clearField },
	            ' clear '
	          )
	        );
	      };
	
	      return App;
	    }(_react2.default.Component);
	
	    return _react2.default.createElement(App, null);
	  });
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Browser = function Browser(_ref) {
	  var image = _ref.image,
	      children = _ref.children,
	      _ref$style = _ref.style,
	      style = _ref$style === undefined ? {} : _ref$style;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "browser-mockup" },
	    children ? _react2.default.createElement(
	      "div",
	      { className: "browser-content", style: style },
	      children
	    ) : _react2.default.createElement("img", { src: image })
	  );
	};
	
	exports.default = Browser;
	module.exports = exports["default"];

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(295);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Phone = function Phone(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { className: 'iPhone' },
	    _react2.default.createElement(
	      'div',
	      { className: 'iPhoneInner' },
	      _react2.default.createElement('div', { className: 'camera' }),
	      _react2.default.createElement('div', { className: 'smallTopCirc' }),
	      _react2.default.createElement('div', { className: 'oval' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'iScreen' },
	        _react2.default.createElement(
	          'div',
	          { style: { padding: 15 } },
	          children
	        )
	      ),
	      _react2.default.createElement('div', { className: 'circButton' })
	    )
	  );
	};
	
	exports.default = Phone;
	module.exports = exports['default'];

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(125);
	
	var _Browser = __webpack_require__(208);
	
	var _Browser2 = _interopRequireDefault(_Browser);
	
	var _Phone = __webpack_require__(209);
	
	var _Phone2 = _interopRequireDefault(_Phone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Preview = function Preview(_ref) {
	  var children = _ref.children;
	
	  if ((0, _utils.isNative)()) {
	    return _react2.default.createElement(
	      _Phone2.default,
	      null,
	      children
	    );
	  }
	  return _react2.default.createElement(
	    _Browser2.default,
	    null,
	    ' ',
	    children,
	    ' '
	  );
	};
	
	exports.default = Preview;
	module.exports = exports['default'];

/***/ }),

/***/ 295:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = exports.cycleValueAround = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(125);
	
	var _isArray = __webpack_require__(100);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	
	var deleteLinks = document.querySelectorAll('.remark-visible .remark-code-line');
	
	Array.from(deleteLinks).forEach((link, index) => {
	    link.addEventListener('click', function(event) {
	        console.log(index)
	    });
	})
	
	 */
	var cycleValueAround = exports.cycleValueAround = function cycleValueAround(current, change, max) {
	  var changed = current + change;
	
	  if (changed === max) {
	    return current;
	  } else if (changed === -1) {
	    return current;
	  }
	
	  return changed;
	};
	
	var DIRECTIONS = {
	  LEFT: 'left',
	  RIGHT: 'right'
	};
	
	var hlClass = 'remark-code-line-highlighted';
	
	var Presentation = function (_Component) {
	  _inherits(Presentation, _Component);
	
	  function Presentation() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Presentation);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      show: false,
	      lines: [],
	      highlighted: null
	    }, _this.moveHiglighted = function (direction) {
	      var _this$state = _this.state,
	          highlighted = _this$state.highlighted,
	          lines = _this$state.lines;
	
	      var newValue = 0;
	
	      if (highlighted === null) {
	        newValue = 0;
	      } else {
	        newValue = cycleValueAround(highlighted, direction === DIRECTIONS.LEFT ? -1 : 1, lines.length);
	      }
	
	      _this.setState({ highlighted: newValue });
	    }, _this.initSlideshow = function () {
	      var context = _this.props.data.sitePage.context;
	      var content = context.content,
	          fileName = context.fileName;
	
	
	      _this.slideshow = window.remark.create({
	        source: (0, _utils.getMarkdownContent)(content),
	        highlightLines: true,
	        highlightStyle: 'dark',
	        highlightSpans: false,
	        highlightLanguage: 'javascript',
	        navigation: {
	          scroll: false
	        },
	        container: _this.ref
	      });
	
	      setTimeout(function () {
	        if (window.location.hash) {
	          var hash = parseInt(window.location.hash.split('#')[1]);
	          var currentIndex = _this.slideshow.getCurrentSlideIndex();
	          if (currentIndex !== hash) {
	            _this.slideshow.gotoSlide(hash);
	            _this.setState({
	              show: true
	            });
	          }
	        } else {
	          _this.setState({
	            show: true
	          });
	        }
	      }, 0);
	
	      _this.slideshow.on('afterShowSlide', function (slide) {
	        var elemId = document.querySelector('.remark-visible .remark-slide-content').id;
	
	        if (elemId) {
	          _this.clearCurrentClasses();
	          var lines = elemId.split('slide-')[1].split(',');
	          var linesState = [];
	          lines.forEach(function (line) {
	            if (line.includes('-')) {
	              var _line$split = line.split('-'),
	                  from = _line$split[0],
	                  to = _line$split[1];
	
	              linesState.push([parseInt(from), parseInt(to)]);
	            } else if (line !== '' && line.trim() !== '') {
	              linesState.push(parseInt(line));
	            }
	          });
	          _this.setState({ lines: linesState, highlighted: null });
	        } else {
	          _this.setState({ highlighted: null, lines: [] });
	        }
	        window.location.hash = slide.getSlideIndex() + 1;
	      });
	
	      try {
	        var initExample = __webpack_require__(495)("./" + fileName + '/' + fileName + '.js');
	        setTimeout(initExample, 1000);
	      } catch (err) {}
	    }, _this.onKeyDown = function (e) {
	      var keys = {
	        i: function i() {
	          return _this.moveHiglighted(DIRECTIONS.LEFT);
	        },
	        o: function o() {
	          return _this.moveHiglighted(DIRECTIONS.RIGHT);
	        },
	        r: _this.resetHighlightedLines
	      };
	
	      keys[e.key] && keys[e.key]();
	    }, _this.clearCurrentClasses = function () {
	      document.querySelectorAll('.remark-visible .remark-code-line').forEach(function (line) {
	        line.classList.remove(hlClass);
	      });
	    }, _this.resetHighlightedLines = function () {
	      _this.clearCurrentClasses();
	      _this.setState({ highlighted: null });
	    }, _this.getCurrentLines = function () {
	      return document.querySelectorAll('.remark-visible .remark-code-line');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Presentation.prototype.componentDidMount = function componentDidMount() {
	    window.addEventListener('keydown', this.onKeyDown);
	    this.initSlideshow();
	  };
	
	  Presentation.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('keydown', this.onKeyDown);
	  };
	
	  Presentation.prototype.componentWillUpdate = function componentWillUpdate(nextProps, _ref) {
	    var highlighted = _ref.highlighted;
	
	    if (highlighted !== null && this.state.highlighted !== highlighted) {
	      var lines = this.getCurrentLines();
	      this.clearCurrentClasses();
	
	      var currentLine = this.state.lines[highlighted];
	
	      lines.forEach(function (line, index) {
	        if ((0, _isArray2.default)(currentLine)) {
	          var from = currentLine[0],
	              to = currentLine[1];
	
	          if (index >= from - 1 && index <= to - 1) {
	            line.classList.add(hlClass);
	          }
	        } else {
	          if (index === currentLine - 1) {
	            line.classList.add(hlClass);
	          }
	        }
	      });
	    }
	  };
	
	  Presentation.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (window.location.hostname === 'localhost') {
	      // this.setState({show: false}, () => {
	      // this.initSlideshow();
	      // });
	    }
	  };
	
	  Presentation.prototype.render = function render() {
	    var _this2 = this;
	
	    var _state = this.state,
	        show = _state.show,
	        lines = _state.lines;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement('div', {
	        ref: function ref(_ref2) {
	          _this2.ref = _ref2;
	          if (_ref2) {
	            _ref2.focus();
	            _ref2.click();
	          }
	        },
	        style: { width: '100vw', height: '100vh', opacity: show ? 1 : 0 }
	      }),
	      lines.length > 0 && _react2.default.createElement('div', { className: 'dot' })
	    );
	  };
	
	  return Presentation;
	}(_react.Component);
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = Presentation;

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.render = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(102);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Preview = __webpack_require__(210);
	
	var _Preview2 = _interopRequireDefault(_Preview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var render = exports.render = function render(element, jsx) {
	  return _reactDom2.default.render(_react2.default.createElement(
	    _Preview2.default,
	    null,
	    jsx()
	  ), document.getElementById(element));
	};

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getMarkdownContent = exports.replaceMultipleInString = exports.isNative = exports.replaceAll = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _each = __webpack_require__(379);
	
	var _each2 = _interopRequireDefault(_each);
	
	var _reduceObject = __webpack_require__(488);
	
	var _reduceObject2 = _interopRequireDefault(_reduceObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var replaceAll = exports.replaceAll = function replaceAll(from, to, str) {
	  to = to.replace(/\$/g, '$$$$');
	  return str.replace(new RegExp(from.replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|<>\-\&])/g, '\\$&'), 'g'), to);
	};
	
	var isNative = exports.isNative = function isNative() {
	  return window.location.search.includes('native=true');
	};
	
	var replaceMultipleInString = exports.replaceMultipleInString = function replaceMultipleInString(replaceObject, string, inverse) {
	  var modified = string;
	
	  (0, _each2.default)(replaceObject, function (value, key) {
	    var to = inverse ? key : value;
	    var from = inverse ? value : key;
	    modified = replaceAll(from, to, modified);
	  });
	
	  return modified;
	};
	
	var getMarkdownContent = exports.getMarkdownContent = function getMarkdownContent(data) {
	  var IS_NATIVE = isNative();
	
	  var elements = {
	    div: 'View',
	    span: 'Text',
	    img: 'Image',
	    button: 'Button',
	    input: 'TextInput'
	  };
	
	  var others = {
	    'onClick={': 'onPress={',
	    'onChange={': 'onChangeText={',
	    '`onChange`': '`onChangeText`'
	  };
	
	  var plain = {
	    IS_WEB: (!IS_NATIVE).toString(),
	    IS_NATIVE: IS_NATIVE.toString()
	  };
	
	  var allElementVariations = (0, _reduceObject2.default)(elements, function (acc, to, from) {
	    acc['</' + from + '>'] = '</' + to + '>';
	    acc['<' + from] = '<' + to;
	    acc['<' + from + '/>'] = '<' + to + '/>';
	    return acc;
	  }, {});
	
	  var all = _extends({}, allElementVariations, others);
	
	  var webToNative = {
	    'e.target.value': 'e'
	  };
	
	  data = replaceMultipleInString(all, data, !IS_NATIVE);
	  data = replaceMultipleInString(plain, data);
	
	  if (IS_NATIVE === true) {
	    data = replaceMultipleInString(webToNative, data);
	  }
	
	  return data;
	};

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./more-react-native-components/more-react-native-components.js": 205,
		"./state-management/state-management.js": 206,
		"./text-input/text-input.js": 207
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 495;


/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-presentation-js-c07992457c9ab063d126.js